module.exports = {"370112001":"山大路街道","370112002":"洪家楼街道","370112003":"东风街道","370112004":"全福街道","370112007":"华山街道","370112008":"荷花路街道","370112009":"王舍人街道","370112010":"鲍山街道","370112011":"郭店街道","370112012":"唐冶街道","370112013":"港沟街道","370112016":"董家街道","370112017":"彩石街道","370112018":"仲宫街道","370112019":"柳埠街道","370112020":"唐王街道","370112021":"西营街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370112.json
// module id = 1470
// module chunks = 0